
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pass/pass",
      function () {
        return require("private-next-pages/pass/pass/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pass/pass"])
      });
    }
  